import styled, { createGlobalStyle } from "styled-components";
import fontBoltsSfRegular from "../../assets/fonts/bolts.sf.regular.ttf";
import vladimir from "../../assets/fonts/vladimir.ttf";

export const GlobalStyle = createGlobalStyle`
  body {
    min-width: 100%;
    min-height: 100vh;
    font-family: "Roboto";
  }

  @font-face {
    font-family: "Bolts SF Regular";
    src: url(${fontBoltsSfRegular}) format("truetype");
    font-weight: normal;
  }

  @font-face {
    font-family: "Vladimir";
    src: url(${vladimir}) format("truetype");
    font-weight: normal;
  }
`;

export const Emphasize = styled.span`
  color: #4e74a2;
`;

export const StrikeOut = styled.span`
  text-decoration: line-through;
  font-weight: normal;
`